import { useEffect } from 'react'
import isEqual from 'lodash-es/isEqual'

import {
  checkEmailBlackList,
  EMAIL_CREATION_FORM_BLACK_LIST_API_PARAM,
  EMAIL_CREATION_FORM_FIELD_NAME_FROM,
  EMAIL_CREATION_FORM_FIELD_NAME_PRINTER,
  getEmailFormAccountsListForBlackListVerification,
} from '../../../Email'
import { isDocFlowSendingWidgetTypeEmailSettings } from '../../DocFlowSending'
import {
  getBlockedRecipients,
  getDocFlowEmailFlattenRecipients,
} from '../../DocFlowWidgets'
import { useDocFlowSendingContext } from '../useDocFlowSendingContext'

export function useDocFlowEmailBlackList({
  widgetNotifications,
  onPrependNotification,
  onRemoveNotification,
}) {
  const {
    activeWidget,
    emailBlackList,
    processData,
    setEmailBlackList,
    setProcessDataLoading,
  } = useDocFlowSendingContext()

  useEffect(() => {
    if (!emailBlackList || emailBlackList?.length === 0) {
      onRemoveNotification(widgetNotifications.recipientsInBlackList.id)
    }
  }, [emailBlackList])

  useEffect(() => {
    const updatedBlackList = getBlockedRecipients(
      getDocFlowEmailFlattenRecipients(processData?.email_participants)
    )

    if (
      isDocFlowSendingWidgetTypeEmailSettings(activeWidget) &&
      emailBlackList &&
      updatedBlackList?.length > 0
    ) {
      onPrependNotification(widgetNotifications.recipientsInBlackList)

      if (!isEqual(emailBlackList, updatedBlackList)) {
        setEmailBlackList(updatedBlackList)
      }
    }
  }, [activeWidget])

  function checkDocFlowEmailBlackList(values) {
    setProcessDataLoading(true)
    const accounts = getEmailFormAccountsListForBlackListVerification(
      values,
      values[EMAIL_CREATION_FORM_FIELD_NAME_PRINTER]
    )

    const recipientsInBlackList = checkEmailBlackList({
      [EMAIL_CREATION_FORM_BLACK_LIST_API_PARAM]: accounts,
      account: values[EMAIL_CREATION_FORM_FIELD_NAME_FROM]?.value,
    })
      .then(({ data }) => {
        if (data.length > 0) {
          onPrependNotification(widgetNotifications.recipientsInBlackList)
          setEmailBlackList(data)

          return true
        } else {
          setEmailBlackList(null)

          onRemoveNotification(widgetNotifications.recipientsInBlackList.id)
        }
      })
      .finally(() => {
        setProcessDataLoading(false)
      })

    return recipientsInBlackList
  }

  return {
    checkDocFlowEmailBlackList,
  }
}
